import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dealer-payment',
  templateUrl: './dealer-payment.component.html'
})
export class DealerPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
